module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/logo_save.37f8f829.png";